module.exports = __webpack_public_path__ + "static/ants-among-elephants-fb5a5b00e99c921f3c400dddc659975b.jpg";